@if (isOpen) {
    <div class="modal-wrapper" [class.inline-mode]="inline" [@.disabled]="inline">
        <div class="modal-backdrop" @backdrop (click)="onBackdropClick($event)">
            <div class="modal-content"
                [ngClass]="[size, contentClass]"
                @modalContent>
                <!-- Modal Header -->
                @if (title || showCloseButton) {
                    <div class="modal-header" [class.has-header-left]="showHeaderLeft">
                        @if (showHeaderLeft) {
                            <div class="modal-header-left">
                                <ng-content select="[header-left]"></ng-content>
                            </div>
                        }
                        @if (title) {
                            <div class="modal-title">{{ title }}</div>
                        }
                        <div class="modal-header-right">
                            <ng-content select="[header-actions]"></ng-content>
                            @if (showCloseButton) {
                                <button class="modal-close-btn" (click)="$event.stopPropagation(); handleClose()"
                                    aria-label="Close modal">
                                    <hugeicons-icon [icon]="closeIcon" [size]="24" color="currentColor"></hugeicons-icon>
                                </button>
                            }
                        </div>
                    </div>
                }
                <!-- Modal Body -->
                <div class="modal-body">
                    <ng-content></ng-content>
                </div>
                <!-- Modal Footer -->
                @if (showFooter) {
                    <div class="modal-footer"
                        [class.align-left]="footerAlign === 'left'"
                        [class.align-center]="footerAlign === 'center'"
                        [class.align-right]="footerAlign === 'right'">
                        <!-- Custom projected content takes precedence -->
                        <ng-content select="[footer]"></ng-content>

                        <!-- Default footer buttons -->
                        @if (showCancelButton) {
                            <button type="button" class="btn btn-md btn-default" (click)="handleCancel()">
                                {{ cancelButtonText }}
                            </button>
                        }
                        @if (showSubmitButton) {
                            <button type="button" class="btn btn-md btn-primary" [disabled]="submitButtonDisabled"
                                (click)="handleSubmit()">
                                {{ submitButtonText }}
                            </button>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
}
